const safeCalendarDate = (value) => typeof value === 'string' && value !== '' ? new Date(value) : undefined;
export { safeCalendarDate };
